import { getCollabSpaceStore } from '../store/store';
import type { CollabSpaceViewState } from '../store/schema';

export function getViewStateById(viewStateId: string): CollabSpaceViewState {
    const store = getCollabSpaceStore().entries.get(viewStateId);
    return store;
}

export const getShareLink = (viewStateId: string) => {
    return getViewStateById(viewStateId)?.shareLink;
};

export const isCollabSpacePresent = (viewStateId: string) => {
    return getViewStateById(viewStateId)?.isCollabSpacePresent;
};

export const isCollabAllowed = (viewStateId: string) => {
    return getViewStateById(viewStateId)?.collabAllowed;
};

export const hasFluidLinkFailed = (viewStateId: string) => {
    return getViewStateById(viewStateId)?.fluidLinkFailed;
};

export const isCollabSpaceExplicitlyDisabled = (viewStateId: string) => {
    return getViewStateById(viewStateId)?.isCollabSpaceExplicitlyDisabled;
};

export const getCreationSource = (viewStateId: string) => {
    return getViewStateById(viewStateId)?.creationSource;
};
